const nlFieldAbout = document.querySelectorAll('[name=about]');

nlFieldAbout.forEach(el => {
    if (!(el.value.trim() === '')) {
        console.log(el);

        return;
    }

    el.closest('.input').remove();
});
